import { useMemo } from "react";

import { Dialog, Link, Paper, Typography } from "@mui/material";

import {
  selectGeoCodeResult,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { Button } from "@covertree/ui";

import { SALES_EMAIL_ADDRESS } from "@covertree/consts";
import { getFullStateName } from "@utils/getFullStateName";

interface RejectedAppointmentInJITStateModalProps {
  open: boolean;
  onClose: () => void;
}

export function RejectedAppointmentInJITStateModal({
  open,
  onClose,
}: RejectedAppointmentInJITStateModalProps) {
  const newHomeGeoCode = useNewBusinessSelector(selectGeoCodeResult);

  const fullStateName = useMemo(
    () => (newHomeGeoCode?.state ? getFullStateName(newHomeGeoCode.state) : ""),
    [newHomeGeoCode]
  );

  return (
    <Dialog open={open} onClose={onClose}>
      <Paper
        sx={{
          marginX: 5,
          marginY: 3,
          textAlign: "center",
          boxShadow: "none",
        }}>
        <Typography
          sx={{
            marginX: 3,
            marginY: 2,
          }}>
          Your appointment in{" "}
          <Typography
            component="span"
            sx={(theme) => ({ color: theme.colors.green3 })}>
            {fullStateName}
          </Typography>{" "}
          was rejected. If you believe this is an error, please contact us at{" "}
          <Link color="secondary" href={`mailto:${SALES_EMAIL_ADDRESS}`}>
            {SALES_EMAIL_ADDRESS}
          </Link>
          .
        </Typography>
        <Button sx={{ marginX: 3, marginY: 2 }} onClick={onClose}>
          Done
        </Button>
      </Paper>
    </Dialog>
  );
}
